<template>

<div class="use-card table-hook fadeInRight">
    <div class="title-box">
        <span class="m-title">月报列表</span>
        <el-form inline v-model="form" class="hook right themed-form search-form" style="line-height: 40px;">
            <el-form-item label="月份:">
                <el-date-picker v-model="form.month" type="month"  value-format="yyyy-MM" placeholder="选择月" style="width:100%"></el-date-picker>
            </el-form-item>
            <el-form-item label="运营商:">
                <el-select v-model="form.accountId" filterable>
                    <el-option v-for="(item,index) in accountList" :label="item.accountName" :value="item.id" :key="index"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="产品类型:">
                <el-select v-model="form.productType" filterable>
                    <el-option label="请选择" value=""></el-option>
                    <el-option v-for="(item,index) in w_PRODUCT_" :label="item.groupName" :value="item.dictValue" :key="index"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" icon="el-icon-search" class="themed-button" @click="searchTable">搜索查询</el-button>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" icon="el-icon-download" class="themed-button" @click="exportExcel">导出</el-button>
            </el-form-item>
        </el-form>
    </div>
    <div class="content-box">
        <el-table ref="table" :data="tableData" stripe border :max-height="maxTableHeight">
            <el-table-column label="月份" prop="month"></el-table-column>
            <el-table-column label="运营商" prop="accountName"></el-table-column>
            <el-table-column label="产品类型" prop="productType">
                <template  slot-scope="scope">
                    <span>{{productTypeName(scope.row.productType)}}</span>
                </template>
            </el-table-column>
            <el-table-column label="当月充值额" prop="money"></el-table-column>
            <el-table-column label="当月分摊收入" prop="moneyAve"></el-table-column>
            <el-table-column label="当月分摊返利" prop="rebateAve"></el-table-column>
            <el-table-column label="成本" prop="cost" show-overflow-tooltip></el-table-column>
            <!-- <el-table-column label="统计时间" prop="createTime" show-overflow-tooltip></el-table-column> -->
            <el-table-column label="操作">
                <template  slot-scope="scope">
                    <el-button type="primary" class="themed-button" @click="updateFile(scope.row)">编辑</el-button>
                </template>
            </el-table-column>
        </el-table>
    </div>
    <div class="pagination">
        <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[5, 10, 15, 50,100,1000]"
        :page-size="pageSize"
        background
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
        </el-pagination>
    </div>
    <el-dialog title="编辑" :visible.sync="dialogBox">
        <el-form label-position="right" label-width="100px" :model="dialogForm" ref="dialogForm">
            <el-form-item label="月份:" >
                <el-input disabled v-model="dialogForm.month"></el-input>
            </el-form-item>
            <el-form-item label="运营商:" >
                <el-select v-model="dialogForm.accountId" filterable disabled>
                    <el-option v-for="(item,index) in accountList" :label="item.accountName" :value="item.id" :key="index"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="产品类型:" >
                <el-select v-model="dialogForm.productType" filterable disabled>
                    <el-option label="请选择" value=""></el-option>
                    <el-option v-for="(item,index) in w_PRODUCT_" :label="item.groupName" :value="item.dictValue" :key="index"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="当月充值额:" >
                <el-input disabled v-model="dialogForm.money"></el-input>
            </el-form-item>
            <el-form-item label="当月分摊收入:" >
                <el-input disabled v-model="dialogForm.moneyAve"></el-input>
            </el-form-item>
            <el-form-item label="当月分摊返利:" >
                <el-input disabled v-model="dialogForm.rebateAve"></el-input>
            </el-form-item>
            <el-form-item label="成本:" >
                <el-input v-model="dialogForm.cost"></el-input>
            </el-form-item>
            
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button type="primary" class="themed-button" @click="dialogSave">确定</el-button>
        </div>
    </el-dialog>
</div>

</template>

<script type="text/ecmascript-6">

import {getAccountList,monthReportList,syncExport,monthReportEdit} from '@/api/staticsManagement/cardUseCycel.js'
import {messageBox,confirmBox} from '@/utils/common.js'

import resize from '@/mixins/resize.js'
import dictGroup from '@/mixins/dictGroup.js'

export default {
    name:'monthlyReportList',
    mixins:[resize,dictGroup],
    data(){
        return {
            form:{
                month:'',
                accountId:'',
                productType:''
            },
            accountList:[],
            tableData:[],
            pageSize:15,
            currentPage:1,
            total:0,
            dialogBox:false,
            dialogForm:{},
        }
    },
    mounted(){
        this._getAccountList()
        this._monthReportList()
    },
    methods:{
        dialogSave(){
            let params = {
               id: this.dialogForm.id,
               cost:this.dialogForm.cost
            }
            monthReportEdit(params).then(res=>{
                messageBox(this,'编辑成功')
                this._monthReportList()
                this.dialogBox = false
            })
        },
        updateFile(data){
            this.dialogBox = true
            this.dialogForm = data
            if(this.dialogForm.productType){
                this.dialogForm.productType = this.dialogForm.productType +''
            }
        },
        searchTable(){
            this._monthReportList()
        },
        exportExcel(){
            syncExport(this.form).then(res=>{
                if (res.system_result_key == '0') {
                    this.$alert('导出成功，请到导出记录中下载', '提示', {
                        confirmButtonText:'确定',
                    }).then(()=>{
                        this.$router.push('/tob/i_export_list')
                    });
                }else{
                    this.$message({
                        showClose: true,
                        message: res.system_result_message_key,
                        type: 'error'
                    });
                }
            })
        },
        handleSizeChange(val){
            this.pageSize = val
            this._monthReportList()
        },
        handleCurrentChange(val){
            this.currentPage = val
            this._monthReportList()
        },
        productTypeName(productType){
            let result = this.w_PRODUCT_.find((item)=>{
                return item.dictValue == productType
            })
            if(!result){
                return '-'
            }
            if(result.label){
                return result.label
            }else{
                return '-'
            }
        },
        _getAccountList(){
            getAccountList().then((res)=>{
                this.accountList = res
            })
        },
        _monthReportList(){
            let params = {}
            params.pageSize = this.pageSize
            params.pageNo = this.currentPage
            monthReportList(Object.assign(params,this.form)).then((res) => {
                this.tableData = res.rows
                this.pageSize = res.pageSize
                this.currentPage = res.pageNo
                this.total = res.total
            })
        }
    }
}
</script>
